var Cookies = {
    AUTH_TOKEN: 'Auth_Token',
    REGION_LIST: 'regionlist',
    HOME_PAGE_TYPE: 'csVarSelection',
    REFERRER: 'Doc.Referrer',
    CUSTOMER_IDENTIFIER: 'CustomerIdentifier',
    BEV_CART: 'BEV.Cart',
    SEGMENT_SIGNED_UP: 'segmentSignedUp',
    SEGMENT_SIGNED_UPDATE: 'segmentSignedUpdate',
    SEGMENT_SIGNED_IN: 'segmentSignedIn',
    SERVER_TIME: 'sst1'
};
export default Cookies;
